import { observable } from 'mobx';

const ACCOUNT_SAVE_KEY = 'ADMIN_ACCOUNT_SAVE_KEY';
const TOKEN_SAVE_KEY = 'ADMIN_TOKEN_SAVE_KEY';

class UserInfoStore {
	token: string | null;
	@observable email: string | null;

	constructor() {
		this.email = localStorage.getItem(ACCOUNT_SAVE_KEY);
		this.token = localStorage.getItem(TOKEN_SAVE_KEY);
	}

	setTokenAndAccount = (token: string, email: string) => {
		this.token = token;
		this.email = email;

		localStorage.setItem(TOKEN_SAVE_KEY, token);
		localStorage.setItem(ACCOUNT_SAVE_KEY, email);
	};

	updateAccount = (email: string) => {
		this.email = email;

		localStorage.setItem(ACCOUNT_SAVE_KEY, email);
	};

	clearToken = () => {
		this.token = null;
		this.email = null;
	};
}

const UserInfo = new UserInfoStore();
export default UserInfo;
